import React from "react";
import { withRouter } from "react-router-dom";
import styles from "./WelcomePanel.module.scss";
import { connect } from "react-redux"
import { submitUserLoginFormAction, submitUserForgotPasswordAction } from "store/actions/Actions";

/**
 *
 * @param {String} type - login/register/site-select - default is login
 * @param {String} className - additional className to add to mid section
 */
const WelcomePanel = props => {
    // const history = useHistory();
    const year = new Date().getFullYear();
    return (
        <div className={styles["login-panel-wrap"]} onClick={props.onClick || null}>
            <div className={styles["login-banner"]}>
                <p>
                    The new Guard 4.1 is here.  We hope you enjoy the new look, feel, and functionality.
                    <br />
                    Ask your coach about new regulations like OSHA, HB 300, PHIPA, and PIPEDA.
                </p>
            </div>
            <div className={styles["login-panel"]}>{props.children}</div>
            <div className={styles.copyright}>&#169; {`${year}`} Compliancy Group LLC</div>
        </div>
    );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {
    submitUserLoginFormAction,
    submitUserForgotPasswordAction,
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(WelcomePanel));
